module.exports = __webpack_public_path__ + "img/location-category-online@2x.918f0a5.png";